var _toConsumableArray = require("C:\\Users\\David\\Factom\\MFW_Enducker\\MyFactomWallet\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/toConsumableArray");

var sign = require('tweetnacl/nacl-fast').sign,
    Long = require('long'),
    hashSha256 = require('hash.js/lib/hash/sha/256'),
    hashSha512 = require('hash.js/lib/hash/sha/512');

var RCD_TYPE_1 = Buffer.from('01', 'hex'),
    MSB = Long.fromString('8000000000000000', true, 16);

function sha256(data) {
  return Buffer.from(hashSha256().update(data).digest());
}

function sha256d(data) {
  return Buffer.from(hashSha256().update(hashSha256().update(data).digest()).digest());
}

function sha512(data) {
  return Buffer.from(hashSha512().update(data).digest());
}

function toHex(arg) {
  return Buffer.isBuffer(arg) ? arg.toString('hex') : arg;
}

function secretToPublicKey(secret) {
  var key = sign.keyPair.fromSeed(secret);
  return Buffer.from(key.publicKey);
} // Reference implementation:
// https://github.com/FactomProject/factomd/blob/master/common/primitives/varint.go#L78-L105


function encodeVarInt(val) {
  var bytes = [];

  if (val === 0 || val === '0') {
    bytes.push(0);
  }

  var h = Long.fromValue(val, true);
  var start = false;

  if (!h.and(MSB).isZero()) {
    bytes.push(0x81);
    start = true;
  }

  for (var i = 0; i < 9; ++i) {
    var b = h.shiftRightUnsigned(56).toNumber();

    if (b || start) {
      start = true;

      if (i !== 8) {
        b = b | 0x80;
      } else {
        b = b & 0x7f;
      }

      bytes.push(b);
    }

    h = h.shiftLeft(7);
  }

  return Buffer.from(bytes);
}

function isIterable(obj) {
  if (obj == null) {
    return false;
  }

  return typeof obj[Symbol.iterator] === 'function';
}

var flatMap = function flatMap(a, f) {
  var _ref;

  return (_ref = []).concat.apply(_ref, _toConsumableArray(a.map(f)));
};

module.exports = {
  RCD_TYPE_1: RCD_TYPE_1,
  sha256: sha256,
  sha512: sha512,
  sha256d: sha256d,
  toHex: toHex,
  encodeVarInt: encodeVarInt,
  isIterable: isIterable,
  flatMap: flatMap,
  secretToPublicKey: secretToPublicKey
};